// Payment LAYOUT (which checkout option leads: the WeChat-payable Pro
// 30-Day Pass / credit packs vs. the card-only subscription) should be keyed
// on the visitor's browser language, not the page's URL locale.
//
// A zh-browser visitor landing on an EN-locale page (shared link, search
// result, default OS/browser language, etc.) still can't complete a
// card-only Stripe subscription — of 28 recent EN-page sessions from
// zh-browser visitors, 24 saw the card-only subscription as the primary CTA
// and bounced off Stripe untouched, never reaching the WeChat-payable pass
// that was built for exactly this cohort.
//
// Page TEXT (titles, FAQ, feature lists, etc.) stays keyed on the page
// locale — only the payment-block ordering/copy should read this instead of
// `pageLang === 'zh'`.
export function prefersZhPayment(pageLang: string): boolean {
  if (pageLang === 'zh') return true;
  if (typeof navigator === 'undefined') return false;
  const nav = (navigator.languages?.[0] || navigator.language || '').toLowerCase();
  return nav.startsWith('zh');
}

// ---- CNY display hints --------------------------------------------------
// All charges run through Stripe in JPY (or USD) — these are display-only
// "about how much that is in RMB" hints for WeChat-paying visitors who think
// in CNY, not a live FX rate, and are never used for an actual charge amount.
// Rate: 1 JPY ≈ 0.05 CNY (rounded approximation, intentionally not
// live-updated — revisit if it drifts far from the real rate).
export const CNY_HINT_RATE = 0.05;

export function formatCnyHint(priceJpy: number): string {
  return `（约¥${Math.round(priceJpy * CNY_HINT_RATE)}元）`;
}

// Pro Pass prices (JPY, one-time). Must match the prices used by
// subscriptionStore.createPassCheckout / the Stripe price objects — kept here
// only so the CNY hint can be computed without re-hardcoding the numbers.
export const PRO_PASS_PRICE_JPY = 980;
export const DAY_PASS_PRICE_JPY = 200;
